import { render, staticRenderFns } from "./IndexMenulist.vue?vue&type=template&id=9af85be4&scoped=true&"
import script from "./IndexMenulist.vue?vue&type=script&lang=js&"
export * from "./IndexMenulist.vue?vue&type=script&lang=js&"
import style0 from "./IndexMenulist.vue?vue&type=style&index=0&id=9af85be4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9af85be4",
  null
  
)

export default component.exports